export default __webpack_public_path__ + "static/media/about.c2992da7.png";